import { render, staticRenderFns } from "./ContractRenewalBanner.vue?vue&type=template&id=58ee527e&"
import script from "./ContractRenewalBanner.vue?vue&type=script&lang=ts&"
export * from "./ContractRenewalBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports